import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Toolbar from "@mui/material/Toolbar";
import HomeFilledIcon from "@mui/icons-material/HomeFilled";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import LoginIcon from "@mui/icons-material/Login";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import { NavLink } from "react-router-dom";
import { CSSProperties } from "@mui/material/styles";
import SettingsAccessibilityIcon from "@mui/icons-material/SettingsAccessibility";
import { useTranslation } from "react-i18next";

interface SideBarProps {
  drawerWidth: number;
  mobileOpen: boolean;
  handleDrawerTransitionEnd: () => void;
  handleDrawerClose: () => void;
  isLoggedIn: boolean;
  handleLogout: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}

interface MenuItem {
  text: string;
  path: string;
  icon: React.ComponentType;
}

const SideBar = ({
  drawerWidth,
  mobileOpen,
  handleDrawerTransitionEnd,
  handleDrawerClose,
  isLoggedIn,
  handleLogout,
}: SideBarProps) => {
  const { t: tCommon } = useTranslation("common");
  const menuItems: MenuItem[] = [
    { text: "navigation.home", path: "/", icon: HomeFilledIcon },
    { text: "navigation.report", path: "/report", icon: QueryStatsIcon },
    {
      text: "navigation.settings",
      path: "/setting",
      icon: SettingsAccessibilityIcon,
    },
    // { text: "Home", path: "/", icon: HomeFilledIcon },
    // { text: "Report", path: "/report", icon: QueryStatsIcon },
    // { text: "Setting", path: "/setting", icon: SettingsAccessibilityIcon },
  ];

  const baseLinkStyle: CSSProperties = {
    textDecoration: "none",
    color: "inherit",
    display: "block",
  };
  const activeStyle: CSSProperties = {
    backgroundColor: "rgba(0,0,0,0.08)",
  };

  const sideMenu = (
    <div>
      <Toolbar />
      <Divider />
      <List>
        {menuItems.map((item, index) => (
          <NavLink
            key={index}
            to={item.path}
            style={({ isActive }) => {
              return { ...baseLinkStyle, ...(isActive ? activeStyle : {}) };
            }}
          >
            <ListItem disablePadding>
              <ListItemButton onClick={handleDrawerClose}>
                <ListItemIcon>
                  <item.icon />
                </ListItemIcon>
                <ListItemText primary={tCommon(item.text)} />
              </ListItemButton>
            </ListItem>
          </NavLink>
        ))}
        {!isLoggedIn && (
          <>
            <NavLink to={"/login"} style={{ ...baseLinkStyle }}>
              <ListItem disablePadding>
                <ListItemButton>
                  <ListItemIcon>
                    <LoginIcon />
                  </ListItemIcon>
                  <ListItemText primary={tCommon("navigation.login")} />
                </ListItemButton>
              </ListItem>
            </NavLink>
            <NavLink to={"/register"} style={{ ...baseLinkStyle }}>
              <ListItem disablePadding>
                <ListItemButton>
                  <ListItemIcon>
                    <PersonAddAltIcon />
                  </ListItemIcon>
                  <ListItemText primary={tCommon("navigation.signup")} />
                </ListItemButton>
              </ListItem>
            </NavLink>
          </>
        )}
        {isLoggedIn && (
          <ListItem disablePadding>
            <ListItemButton onClick={(e) => handleLogout(e)}>
              <ListItemIcon>
                <LogoutIcon />
              </ListItemIcon>
              <ListItemText primary={tCommon("navigation.logout")} />
            </ListItemButton>
          </ListItem>
        )}
      </List>
    </div>
  );

  return (
    <Box
      component="nav"
      sx={{ width: { md: drawerWidth }, flexShrink: { md: 0 } }}
      aria-label="mailbox folders"
    >
      {/* モバイル用 */}
      <Drawer
        // container={container}
        variant="temporary"
        open={mobileOpen}
        onTransitionEnd={handleDrawerTransitionEnd}
        onClose={handleDrawerClose}
        ModalProps={{
          keepMounted: true, // モバイルで性能改善になる
        }}
        sx={{
          display: { sm: "block", md: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
          },
        }}
        slotProps={{
          root: {
            keepMounted: true, // Better open performance on mobile.
          },
        }}
      >
        {sideMenu}
      </Drawer>

      {/* PC用 */}
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", md: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
          },
        }}
        open
      >
        {sideMenu}
      </Drawer>
    </Box>
  );
};

export default SideBar;
